import advancedSearch from './advanced_search'
import instagram from './instagram'
import editorial from './editorial'

export default [
  { name: 'editorial', service: editorial },
  { name: 'instagram', service: instagram },
  { name: 'advancedSearch', service: advancedSearch }
]
